<template>
    <bs5-base-button variant="primary" size="sm" :loading="loading">
        <slot>{{ $t("common.save") }}</slot>
    </bs5-base-button>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "SaveButton",
    props: {
        loading: { type: Boolean, default: false },
    },
});
</script>